import moment from 'moment'

export const isNullOrEmpty = (val) => {
	if (val == null || val == "" || typeof (val) == undefined) {
		return true;
	} else {
		return false;
	}
}

export const formatNumber = n => {
	n = n.toString()
	return n[1] ? n : '0' + n
}

export const formatDate = timeStr => {
	if (!timeStr) return ''

	const date = new Date(Number(timeStr))

	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()

	return [year, month, day].map(formatNumber).join('-')
}

// 判断有无值并加参数
export const formatUnit = (val, unit = '') => {
	if (unit === '元') {
		return (val ? val : '0') + unit
	}

	return (val ? val : '--') + unit
}

export const formatPercentage = (val) => {
	if (val === 0) return ''

	if (!val) return '0%'

	return (Number(val) * 100).toFixed(2) + '%'
}

export const formatBetweenTime = (val, star, end, num) => {
	const count = moment(end).diff(moment(star), 'days')

	if ((count + 2) < num) {
		return ''
	}

	return val
}

export const formatSystemIcon = (code) => {
	switch (String(code)) {
		case '1':
			return 'icon-anzhuo'
		case '2':
			return 'icon-ios'
		case '3':
			return 'icon-weixin'
		case '4':
			return 'icon-douyin'
		case '5':
			return 'icon-chrome'
		case '6':
			return 'icon-hongmeng'
		default:
			return ''
	}
}

export const formatSystem = (code, name) => {
	let system = ''

	switch (String(code)) {
		case '1':
			system = 'Android'
			break
		case '2':
			system = 'iOS'
			break
		case '3':
			system = '微信小程序'
			break
		case '4':
			system = '抖音小程序'
			break
		case '5':
			system = 'Web网页'
			break
		case '6':
			system = '鸿蒙'
			break
		default:
			system = '未知'
			break
	}

	return name ? name + '-' + system : system
}

export const formatIs = (val, yes, no) => {
	if (Number(val) === 1) {
		return yes
	} else {
		return no
	}
}

// export {
// 	isNullOrEmpty,
// 	formatDate,
// 	formatUnit,
// 	formatPercentage,
// 	formatBetweenTime,
// 	formatSystem,
// 	formatSystemIcon,
// 	formatIs
// }